import { Controller } from "@hotwired/stimulus"

// Handles showing/hiding the "Other" text input field when "Other" option is selected
export default class extends Controller {
  static targets = ["container", "field", "trigger"]

  connect() {
    console.log("OtherInputController connected")
    // Check initial state on page load (for form re-renders with errors)
    this.checkInitialState()
  }

  toggleOther(event) {
    console.log("toggleOther called", event.target)
    const isChecked = event.target.checked || event.target.type === 'radio'
    console.log("isChecked:", isChecked)
    
    if (this.hasContainerTarget && this.hasFieldTarget) {
      if (isChecked) {
        console.log("Showing other input field")
        // Show the text input
        this.containerTarget.classList.remove('hidden')
        this.fieldTarget.focus()
      } else {
        console.log("Hiding other input field")
        // Hide the text input and clear its value
        this.containerTarget.classList.add('hidden')
        this.fieldTarget.value = ''
      }
    } else {
      console.log("Missing targets - container:", this.hasContainerTarget, "field:", this.hasFieldTarget)
    }
  }

  checkInitialState() {
    // For radio buttons or checkboxes that might be pre-selected
    if (this.hasTriggerTarget) {
      const trigger = this.triggerTarget
      console.log("Checking initial state, trigger checked:", trigger.checked)
      if (trigger.checked) {
        this.containerTarget.classList.remove('hidden')
      }
    }
  }
}
